export const borderStyles: any = {
  border: {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#D4D4D8',
    backgroundColor: '#FAFAFA',
    paddingTop: '12px',
  },
};
